import {computed, type ComputedRef} from 'vue'
import {useStore} from 'vuex'
import {useRoute} from 'vue-router'
import qs from 'qs'

export function getNavigatorLanguage(): string {
  return (navigator.languages && navigator.languages.length)
    ? navigator.languages[0]
    : (navigator as any).userLanguage || navigator.language || (navigator as any).browserLanguage || 'en-US'
}

export function useCommon() {
  const store = useStore()
  const route = useRoute()

  const labels: ComputedRef<Record<string, any>> = computed(() => store.getters['mymachine/getConcepts'])

  function translate(value: string, labelsObj: Record<string, any>, key: string | null = null): string {
    if (labelsObj && key && labelsObj[key] && typeof labelsObj[key][value] === 'string') return labelsObj[key][value]
    else if (Object.keys(labelsObj || {}).length > 0) return `{ ${key} | ${value} }`
    else return '~~~~~'
  }

  function translatedLabel(conceptKey: string, conceptPath: string): string {
    return translate(conceptKey, labels.value, conceptPath)
  }

  function updateUrlParam(keyword: string, value: string | null | undefined): void {
    if (window.history && history.replaceState) {
      let _newAddr = location.origin + location.pathname
      if (route.query) {
        const items: Record<string, any> = {...route.query}
        if (value !== null && value !== undefined) {
          items[keyword] = value
        } else {
          delete items[keyword]
        }
        if (Object.entries(items).length > 0) _newAddr += '?' + qs.stringify(items)
      } else if (value !== '') {
        _newAddr += '?' + keyword + '=' + value
      }
      history.replaceState('', '', _newAddr)
    }
  }

  function downloadPdfFile(url: string): void {
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    link.parentNode?.removeChild(link)
  }

  function formatUTCDate(val: string | Date): string {
    const ts = new Date(val)
    const options: Intl.DateTimeFormatOptions = {day: 'numeric', month: 'short', year: 'numeric'}
    const timeDiff = ts.getTimezoneOffset() * 60000
    const adjustedDate = new Date(ts.valueOf() + timeDiff)
    return adjustedDate.toLocaleDateString(getNavigatorLanguage(), options)
  }

  function formatDate(val: string | Date): string {
    const ts = new Date(val)
    const options: Intl.DateTimeFormatOptions = {day: 'numeric', month: 'short', year: 'numeric'}
    return ts.toLocaleDateString(getNavigatorLanguage(), options)
  }

  return {labels, translate, translatedLabel, updateUrlParam, downloadPdfFile, formatUTCDate, formatDate}
}
